var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-3 mb-5"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }